import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'
import { Notification } from '../Notification'

export type SpecialistIneligibleProps = BaseNotificationItemProps & {
  userName: string
  programName: string
  reason: string
  type: 'specialist-ineligible'
}

export function SpecialistIneligible({ userName, programName, reason, ...props }: SpecialistIneligibleProps) {
  return (
    <NotificationItem
      {...props}
      avatar={{
        ...props.avatar,
        addon: <Notification.Addon.Avatar size={props.size} color='red' icon='arrow-down' />,
      }}
      title={`${userName} Specialist is ineligible to work on ${programName}`}
      descriptionAddon={<p className='flex text-sm text-gray-500'>Suspended due to {reason}.</p>}
    />
  )
}
